import {Injectable} from '@angular/core';
import {Router, CanActivate} from '@angular/router';
import {AuthServiceService} from "../shared-services/auth-service.service";
import {GlobalDataService} from "../shared-services/global-data.service";
import {Observable} from "rxjs";
import {of} from "rxjs/observable/of";
import {map, catchError} from "rxjs/operators";
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AuthGuardService implements CanActivate {
    constructor(private router: Router, private authService: AuthServiceService,
                private globalDataService: GlobalDataService, private translate: TranslateService) {
    }

    canActivate(): Observable<boolean> {
        return this.authService.getMe().pipe(
            map((data) => {
                this.authService.isLoggedIn = true;
                this.globalDataService.currentUser = data;
                return true;
            }), catchError((error) => {
                this.authService.isLoggedIn = false;
                this.router.navigate([this.globalDataService.getRemoteContext() + '/' + this.translate.currentLang]);
                return of(false);
            })
        );
    }
}